module.exports = __webpack_public_path__ + "static/media/Imaryuk4-brochure.cbb4d330.gif";